import styled from 'styled-components'

import { theme } from '@/styles/theme'

import { PDFItem, PDFItemType } from './PDFItem'

type Props = {
  pdfList: readonly PDFItemType[]
}

export const PDFList = ({ pdfList }: Props) => {
  return (
    <ul>
      {pdfList.map((pdf) => (
        <Item key={pdf.id}>
          <PDFItem {...pdf} />
        </Item>
      ))}
    </ul>
  )
}

const Item = styled.li`
  display: flex;
  align-items: center;
  :not(:last-child) {
    border-bottom: 1px solid ${theme.colors.backgroundBlue};
  }
`
